import { render, staticRenderFns } from "./ProductWeight2.vue?vue&type=template&id=40d190a2&scoped=true&"
import script from "./ProductWeight2.vue?vue&type=script&lang=js&"
export * from "./ProductWeight2.vue?vue&type=script&lang=js&"
import style0 from "./ProductWeight2.vue?vue&type=style&index=0&id=40d190a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d190a2",
  null
  
)

export default component.exports